export const SET_SIDEBAR_EXPANDED = 'SET_SIDEBAR_EXPANDED';
export const SET_SIDEBAR_EFFECTIVE_EXPANDED = 'SET_SIDEBAR_EFFECTIVE_EXPANDED';
